import React from 'react';
import "../../assets/css/master.css";

import TemplateDashboard from "../../components/TemplateDashboard";
// import HomeContent from "./components/HomeContent"
  
const Sensores = () => {

    return (
    <>

        <TemplateDashboard pretitle="Vista general" title="Sensores">
            {/* <HomeContent /> */}
        </TemplateDashboard>
        
    </>
    )
};
  
export default Sensores;